module.exports = __webpack_public_path__ + "static/media/16UNODC21.241ff39d.jpg";